import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import { LoadingButton } from "@mui/lab";
import { alpha, useTheme } from "@mui/material";

import { marketplaceTypography as mt } from "../constants/marketplaceTypography";

interface WooCheckoutTriggerButtonProps {
  draftItemCount: number;
  loading?: boolean;
  onCheckout: () => void;
}

/** Botão de finalizar solicitação — desabilitado até haver itens no pedido. */
export function WooCheckoutTriggerButton({
  draftItemCount,
  loading = false,
  onCheckout,
}: WooCheckoutTriggerButtonProps) {
  const theme = useTheme();
  const enabled = draftItemCount > 0;

  return (
    <LoadingButton
      variant="contained"
      disabled={!enabled}
      loading={loading}
      onClick={onCheckout}
      startIcon={<ShoppingBagOutlinedIcon sx={{ fontSize: 18 }} />}
      aria-label={
        enabled
          ? `Finalizar solicitação, ${draftItemCount} itens no pedido`
          : "Finalizar solicitação, adicione produtos ao pedido"
      }
      sx={{
        minHeight: 44,
        height: 44,
        px: 1.5,
        flexShrink: 0,
        whiteSpace: "nowrap",
        textTransform: "none",
        ...mt.button,
        boxShadow: "none",
        bgcolor: enabled ? "success.main" : theme.palette.neutral300.main,
        color: enabled ? "common.white" : theme.palette.neutral600.main,
        "&:hover": {
          boxShadow: "none",
          bgcolor: enabled ? "success.dark" : theme.palette.neutral300.main,
        },
        "&.Mui-disabled": {
          bgcolor: theme.palette.neutral300.main,
          color: theme.palette.neutral600.main,
          border: `1px solid ${alpha(theme.palette.neutral600.main, 0.12)}`,
        },
      }}
    >
      Finalizar solicitação
    </LoadingButton>
  );
}
